import { useFlags } from "launchdarkly-react-client-sdk";

import { useProjectsAccess } from "src/components/layout/nav/sections/hooks/projects";

/** True when the user can open Projects, so work pages may offer to add themselves to one. Same gates as the Projects nav entry. */
export const useProjectsAvailable = (): boolean => {
  const { isEnabled } = useProjectsAccess();
  const { appAmpV2 } = useFlags();
  return isEnabled && Boolean(appAmpV2);
};
